module.exports = __webpack_public_path__ + "static/media/gmail.2f0c4fe5.png";